<script setup lang="ts">
import IRmt4Spinner from '~icons/rmt4/spinner'
import { computed } from 'vue'

const props = defineProps({
  loading: {
    type: Boolean,
    required: false,
    default: false,
  },
  transition: {
    type: String,
    required: false,
    default: 'icon-expand',
  },
  /** size in rems */
  size: {
    type: Number,
    required: false,
    default: 1.125,
  },
  appear: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const styles = computed(() => {
  return {
    'font-size': `${props.size}rem`,
  }
})
</script>

<template>
  <Transition :appear="appear" :name="transition">
    <IRmt4Spinner v-if="loading" :style="styles" class="oen-ui-spinner animate-spin" />
  </Transition>
</template>
